export const ContentTypes = [
  { id: "ALL", value: "ALL" },
  { id: "Images", value: "Image Gallery" },
  { id: "Videos", value: "Video Gallery" },
  { id: "Gallery", value: "Gallery" },
  { id: "Accolades", value: "Accolades" },
  { id: "ServiceCard", value: "Service Card" },
  { id: "Articles", value: "Articles" },
  { id: "VOD", value: "VOD" },
  { id: "Quiz", value: "Quiz" },
  { id: "Poll", value: "Poll" },
];
export const ROW_SIZE = 20;
export const SORT_ORDER = "DESC";
export const SORT_ORDER_ASC = "ASC";

/**
 * Sort choices offered by the content-listing "Sort By" menu.
 * These string values are the single source of truth shared between the
 * header menu, the ?sort= URL param and the API-variable mapper, so they must
 * stay in sync across libs/content and libs/authoring-apis.
 */
export const CONTENT_SORT_VALUES = {
  NEWEST: "newest",
  OLDEST: "oldest",
  TITLE_AZ: "title_az",
  TITLE_ZA: "title_za",
} as const;
export const ContentGalleryTypes = [
  "ALL",
  "ServiceCard",
  "ImageGallery",
  "VideoGallery",
  "Gallery",
  "Accolades",
  "Article",
  "VOD",
  "Quiz",
  "Poll",
  "Event",
];

export const ContentGalleryTypes1 = [
  "ImageGallery",
  "VideoGallery",
  "Gallery",
  "Article",
  "VOD",
  "Quiz",
  "Poll",
  "Event",
];

export const LanguageList = [
  { id: "en", value: "English (UK)" },
  { id: "fr", value: "French" },
  { id: "de", value: "German" },
];

export const DefaultLocale = "en";
export const CATEGORY_CONTENT = "content";
export const CATEGORY_PAGE = "Page";
export const SORTED_ORDER = "ASC";
export const MENU_STATE_DRAFT = "DRAFT";
export const MENU_TAGGING = "Navigation";
export const USERNAME_EMAIL_EXIST = "Username already exist!";
export const CONTENT_TYPES = ["article", "quiz", "poll", "event"];
export const SITE_PAGE = "SitePage";

export const ImageCropOrder = {
  1440: "hero",
  1280: "landscape",
  1024: "card2",
  768: "square",
  600: "card1",
  320: "portrait",
};

export const SNOWPLOW = {
  NA: "NA",
  SNOWPLOW: "snowplow",
  TRACKID: "selfDescribingEvent",
  IMPRESSIONTYPE: "user register Impression",
  REGISTERFROM: "Rendering",
  COLLECTOR_URL: "collector.hcl-x.com",
  APP_ID: "x",
  APP_NAME: "plateform-x-authoring-app",
};
